import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import store from '@/store/store';

export async function enforceNotificationPermission() {
  let permission = 'default';

  if (Capacitor.isNativePlatform()) {
    // Mobile (iOS/Android)
    const permStatus = await PushNotifications.requestPermissions();
    permission = permStatus.receive === 'granted' ? 'granted' : 'denied';
  } else {
    // Web
    if (Notification.permission === 'default') {
      permission = await Notification.requestPermission();
    } else {
      permission = Notification.permission;
    }
  }

  // Update Vuex store
  store.commit('setNotificationPermission', permission);
}